import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

export class CardTwoFill extends Component {
    render() {
        const {tagName,ServiceName,ServiceDesc,ButtonText, BgColor, nLink} = this.props;
        return (
            <div className={"col-12 col-md-4 half-card"}>
                <div className={"card "+ BgColor}>
                    <div className="column white-text">
                        <span className='text-uppercase'>{tagName}</span>
                        <p className="block-heading">{ServiceName}</p>
                        <p>{ServiceDesc}</p>
                        <NavLink to={nLink}  className="white-bordered-button">{ButtonText}</NavLink>
                    </div>
                </div>
            </div>
        );
    }
}

// export default CardTwo;

export class CardTwoOutine extends Component {
    render() {
        const {tagName,ServiceName,ServiceDesc,ButtonText, BgColor, nLink} = this.props;
        return (
            <div className={"col-12 col-md-4 half-card"}>
                <div className={"card outlined"}>
                    <div className="column">
                        <span className='text-uppercase'>{tagName}</span>
                        <p className="block-heading">{ServiceName}</p>
                        <p>{ServiceDesc}</p>
                        <NavLink to={nLink} className="gray-bordered-button-sm">{ButtonText}</NavLink>
                    </div>
                </div>
            </div>
        );
    }
}
